bovoApp.
factory('Billing', ['$http', function($http) {
    return {
      all: function(data) {
        return $http.post('api/bills', data);
      },
      get: function(id) {
        return $http.get('api/bill/' + id);
      },
      new: function(id) {
        return $http.get('api/new-bill');
      },
      delete: function(id) {
        return $http.delete('api/delete-bill/' + id);
      },
      save: function(data) {
        return $http.post('api/save-bill',data);
      },
      update: function(data) {
        return $http.post('api/update-bill',data);
      },
      addPayment: function(data) {
        return $http.post('api/save-bill-payment',data);
      },
      updatePayment: function(data) {
        return $http.post('api/update-bill-payment',data);
      },
      deletePayment: function(id) {
        return $http.delete('api/delete-bill-payment/' + id);
      },
      convertDraftToInvoice: function(id) {
        return $http.post('api/convert-draft-to-invoice', { draft_id: id });
      },
      deleteDraft: function(id) {
        return $http.delete('api/delete-invoice-draft/' + id);
      },
      createManualInvoiceDraft: function(filterData) {
        return $http.post('api/create-manual-invoice-draft', filterData);
      },
      recalculateDraft: function(draftId) {
        return $http.post('api/recalculate-draft', { draft_id: draftId });
      },
      removeOrderFromDraft: function(orderId, billingDirection) {
        return $http.post('api/remove-order-from-draft', {
          order_id: orderId,
          billing_direction: billingDirection || 'delivery'
        });
      },
      getWeightUpdateHistory: function(data) {
        return $http.get('api/weight-update-history', { params: data });
      },
      checkWeightUpdateStatus: function(importId) {
        return $http.get('api/check-weight-update-status/' + importId);
      }
    };
}]);